export const articles = ({ globals, user }) => {
  // Порівняльні числа в текстах продажу — з єдиного джерела правди
  // (globals.comparisons <- config/pricing.json), а не зашиті в копірайті.
  const cmp = globals?.comparisons || {};
  const groupThousands = (n) =>
    String(n ?? "").replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
  return [
    {
      articleId: "Test",
      content: [
        {
          type: "header1",
          value: [
            { type: "text", value: `Важливо, щоб учень ` },
            { type: "lineThrough", value: `промовляв самостійно: ` },
            {
              type: "text",
              value: ` «Вафля, заєць —ваза» `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Будь ласка, не грайтеся у&nbsp;«Ребус-метод» із дітьми, яким ще не&nbsp;виповнилося 4 роки. Малі діти, `,
            },
            {
              type: "lineThrough",
              value: `мовленнєві навички `,
            },
            {
              type: "text",
              value: ` яких ще не закріпилися, здатні всерйоз перенести правила скорочення слів «Ребус-методу» у&nbsp;побутове спілкування і&nbsp;цим спровокувати штучну затримку мовленнєвого розвитку. `,
            },
          ],
        },
        {
          type: "text", // з&nbsp;вкладеннями
          value: [
            { type: "text", value: `Важливо, щоб учень ` },
            { type: "strong", value: `промовляв самостійно: ` },
            {
              type: "text",
              value: ` «Вафля, заєць&nbsp;— ваза», «бублик, лава, вафля&nbsp;— булава». `,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Маска&nbsp;— МА ` },
            { type: "listItem", value: `Вафля&nbsp;— ВА ` },
            { type: "listItem", value: `Кошик&nbsp;— КО ` },
            { type: "listItem", value: `Ложка&nbsp;— ЛО ` },
            { type: "listItem", value: `Листя&nbsp;— ЛИ ` },
            { type: "listItem", value: `Лійка&nbsp;— … ` },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Викладайте і&nbsp;ви свої ` },
            {
              type: "link",
              href: "https://www.facebook.com/RebusMetod",
              value: "сюди на фейсбук",
            },
            { type: "text", value: ` в&nbsp;коментарях нижче або на пошту ` },
            {
              type: "link",
              href: "mailto:rebusmetod@gmail.com",
              value: "rebusmetod@gmail.com",
            },
          ],
        },
        { type: "video", value: "YTLSTKw0K5Y" },
        {
          type: "image",
          value: "rebus-ditky",
        },
        {
          type: "expandable",
          value: [
            { type: "action", value: "Докладніше про це." },
            {
              type: "content",
              value: [
                {
                  type: "text",
                  value:
                    "Особливості розвитку головного мозку дитини такі, що до чотирьох років вона не здатна мислити логічно, їй доступне лише образне мислення. Читання ж вимагає абстрактного мислення, читач має співвідносити образи й&nbsp;узагальнювати їх у&nbsp;поняття. У&nbsp;маленьких дітей також не розвинені ритмічний і&nbsp;понятійний рівень сприйняття, необхідні для читання.",
                },
                {
                  type: "text",
                  value:
                    "Якщо малеча ще не підросла, не переживайте, ви зможете повернутися до навчання пізніше. Поки що вчіть абетку 😊 І краще відразу вчити звуки, а&nbsp;не літери. Вчіть «Б», а&nbsp;не «Бе», «С», а&nbsp;не «Ес». А&nbsp;як підростете трохи, побачимось.",
                },
              ],
            },
          ],
        },
        { type: "text", value: `Якщо ж ви вже дорослі, йдемо далі. ` },
        { type: "button", target: "next", value: "Перейти далі" },
        { type: "button", target: "endLesson", value: "Закінчити урок" },
        {
          type: "button",
          target: "skipOne",
          value: "Пропустити картку",
        },
      ],
    },
    {
      articleId: "ChotyryPlus",
      content: [
        { type: "header1", value: "Розпочнемо гру" },
        {
          type: "text", value: `Для того, щоб комфортно усе налаштувати, вкажіть, будь ласка, вік дитини (ми не зберігаємо дату народження, але приблизний вік допоможе зорієнтуватися з навантаженням):
          ` },
        {
          type: "ageSelector",
          initialData: {
            roundedBirthday: user?.roundedBirthday,
            phone: user?.phone,
            remindersLeft: user?.remindersLeft,
            reminderType: user?.reminderType || "email"
          }
        },
      ],
    },
    {
      articleId: "YakHratysya",
      content: [
        { type: "header1", value: "Як гратися?" },
        { type: "video", value: "TdIWKZad8TI" },
        {
          type: "p",
          value: `Перед вами п’ять подарункових уроків українського «Ребус-методу». Серйозний шлях. Але почнемо з&nbsp;простого. `,
        },
        { type: "p", value: `Нагадаємо правила нашої гри. ` },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Від слова ми беремо лише перший звуковий склад. `,
            },
          ],
        },
        {
          type: "text",
          value: `Усе, що потрібно зробити,&nbsp;— це чітко й&nbsp;ритмічно продекламувати, наче віршики, кілька прикладів: `,
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Маска&nbsp;— МА ` },
            { type: "listItem", value: `Вафля&nbsp;— ВА ` },
            { type: "listItem", value: `Кошик&nbsp;— КО ` },
            { type: "listItem", value: `Ложка&nbsp;— ЛО ` },
            { type: "listItem", value: `Листя&nbsp;— ЛИ ` },
            { type: "listItem", value: `Лійка&nbsp;— … ` },
          ],
        },
        {
          type: "text",
          value: `Тут можна ненадовго призупинитися, запрошуючи дитину пограти. Але не слід зволікати, і&nbsp;ми продовжуємо: `,
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `… ЛІ ` },
            { type: "listItem", value: `Ремінь&nbsp;— РЕ ` },
            { type: "listItem", value: `Келих&nbsp;— ... ` },
            { type: "listItem", value: `Око&nbsp;— О ` },
            { type: "listItem", value: `Їжа&nbsp;— … ` },
          ],
        },
        {
          type: "text",
          value: `Можна гратися словами, а&nbsp;можна й&nbsp;іменами: `,
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Ваня&nbsp;— ВА ` },
            { type: "listItem", value: `Таня&nbsp;— ТА ` },
            { type: "listItem", value: `Соня&nbsp;— СО ` },
            { type: "listItem", value: `Тоня&nbsp;— ТО ` },
            { type: "listItem", value: `Ігор&nbsp;— І ` },
            { type: "listItem", value: `Уля&nbsp;— У&nbsp;` },
          ],
        },
        { type: "button", target: "next", value: "Продовжити гру!" },
      ],
    },
    {
      articleId: "ShchoDali",
      content: [
        { type: "header1", value: "Що далі?" },
        { type: "video", value: "9LoXbyhdsvo" },
        {
          type: "text",
          value: `П’ять хвилин веселих тренувань минуло, і&nbsp;учень готовий до другого правила: `,
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `З кількох слів, гучно й&nbsp;ритмічно продекламованих уголос одне за одним, ми виділяємо лише перші їхні склади і&nbsp;дослухаємось, яке нове слово у&nbsp;нас вийшло. `,
            },
          ],
        },
        { type: "text", value: `Так само без пояснень ми читаємо віршик: ` },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Маска-маска&nbsp;— МА-МА ` },
            { type: "listItem", value: `Кошик, ложка&nbsp;— КО-ЛО ` },
            { type: "listItem", value: `Кактус-шапка&nbsp;— КА-ША ` },
            { type: "listItem", value: `Маска-шапка&nbsp;— МА-... ` },
            { type: "listItem", value: `Вафля-заєць&nbsp;— ВА-... ` },
            { type: "listItem", value: `Кошик-заєць&nbsp;— … ` },
          ],
        },
        { type: "button", target: "next", value: "Нумо до гри!" },
      ],
    },
    {
      articleId: "Chudovo",
      content: [
        { type: "header1", value: "Чудово!" },
        { type: "video", value: "a421z9sMMMU" },
        {
          type: "text",
          value: `Але подумаєш&nbsp;— два слова... Складімо відразу три! `,
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Кошик-робот-вафля&nbsp;— КО-РО-ВА ` },
            { type: "listItem", value: `Кошик-робот-напій&nbsp;— ... ` },
            { type: "listItem", value: `Кактус-листя-напій&nbsp;— ... ` },
            { type: "listItem", value: `Дим-тигр-напій&nbsp;— … ` },
          ],
        },
        { type: "button", target: "next", value: "А тепер з картинками!" },
      ],
    },
    {
      articleId: "VyajavlyayetsyaMozhemoITry",
      content: [
        { type: "header1", value: "Виявляється, можемо і&nbsp;три!" },
        {
          type: "text",
          value: `З чотирма буде складніше, але це вже пізніше, на наступних уроках. А&nbsp;поки що час відпочити і&nbsp;порухатись. `,
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Наполегливо раджу проходити не більше одного уроку за день. `,
            },
            {
              type: "text",
              value: `Хіба що дитина вже скоро-скоро піде до школи або вже вчиться у перших класах. І сама просить про більше навантаження. `,
            },
          ],
        },
        { type: "header2", value: "Навчити читати за 10 хвилин?" },
        {
          type: "text",
          value: `Із появою зорових образів починається процес справжнього читання. Ми ще не читаємо по літерах, але вже читаємо! `,
        },
        { type: "text", value: `Скільки часу нам на це знадобилося? ` },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `І ще одна порада. `,
            },
          ],
        },
        { type: "button", target: "next", value: "До поради" },
      ],
    },
    {
      articleId: "YakschoVazhkoZbahnutyPryntzyp",
      content: [
        { type: "header1", value: "Якщо важко збагнути принцип" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Іноді діткам важко дається наше перше правило: «маска&nbsp;— МА». `,
            },
            {
              type: "text",
              value: `Часто таке трапляється із&nbsp;тими малюками, яких дорослі вже привчили визначати у&nbsp;слові його першу літеру / фонему («маска&nbsp;— М»). Така дитина ще пам’ятає, як зовсім нещодавно, коли вона казала «маска&nbsp;— МА», її зупиняли і&nbsp;виправляли, пояснюючи, що це не правильно. А&nbsp;тепер чомусь просять повернутися до цієї «неправильності». `,
            },
            { type: "strong", value: `У цьому випадку варто зробити ось що: ` },
          ],
        },
        {
          type: "unorderedList",
          value: [
            {
              type: "listItem",
              value: [
                { type: "text", value: `По-перше, ` },
                { type: "strong", value: `поясніть дитині, ` },
                {
                  type: "text",
                  value: ` що у&nbsp;різних ігор можуть бути різні правила. Ось у&nbsp;цій нашій грі&nbsp;— таке правило: «маска&nbsp;— МА». `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                {
                  type: "text",
                  value: `По-друге, можна піти у&nbsp;зворотному напрямку і&nbsp;`,
                },
                {
                  type: "strong",
                  value: `пограти з&nbsp;дитиною у&nbsp;гру «Вгадай слово за його початком». `,
                },
                {
                  type: "text",
                  value: `«МА&nbsp;— маска», «ЛІ&nbsp;— лійка», «КУ&nbsp;— курка» тощо. Дорослий називає перший склад (МА або ЛІ, або КУ і&nbsp;т.&nbsp;д.), а&nbsp;дитина має усно це слово добудувати, назвати повністю («маска», або «лійка», або «курка»...). Ви можете одразу погодитися з&nbsp;малюком: «Так, я саме це слово і&nbsp;загадав! Молодчинка!». Але можна ускладнити завдання і&nbsp;сказати: «Правильно, на „ку“ може починатися слово „курка“, але я задумав не це слово, а&nbsp;інше. Вгадуй-но далі». Тоді дитина назве вам і&nbsp;«кубик», і&nbsp;«кухню», і&nbsp;«кульку». `,
                },
              ],
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: [
                {
                  type: "text",
                  value: `Ще простіше дитині буде, якщо у&nbsp;вас в&nbsp;запасі є `,
                },
                { type: "strong", value: `набір різноманітних картинок. ` },
              ],
            },
            {
              type: "text",
              value: ` Спочатку ви розглядаєте з&nbsp;малюком ці картинки, називаєте їх, і&nbsp;лише потім граєте у&nbsp;гру «Вгадай слово за його початком». Можна користуватися картками з&nbsp;цього і&nbsp;наступних уроків. У такому разі у&nbsp;дитини в&nbsp;голові вже буде певний набір можливих відповідей. Ви можете грати і&nbsp;у «Знайди картинку», причому загадувати слово по першому складу можна по черзі: одне слово загадуєте ви, і&nbsp;дитина його шукає, інше слово загадує дитина&nbsp;— і&nbsp;тоді потрібну картинку шукаєте ви. `,
            },
          ],
        },
        {
          type: "text",
          value: [{ type: "strong", value: `Так буде легше. ` }],
        },
        { type: "button", target: "endLesson", value: "До плану уроків" },
      ],
    },
    {
      articleId: "ZnayemoSchoRobyty",
      content: [
        { type: "header1", value: "Знаємо, що робити" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Як і&nbsp;минулого разу, почнемо з&nbsp;нових карток. `,
            },
            {
              type: "text",
              value: ` Розширюємо словниковий запас, готуючись до нових слів. Ви допомагаєте знайомитися з&nbsp;картинками. Потім починаємо читати. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Дуже важливо, щоб учень ` },
            { type: "strong", value: `промовляв самостійно: ` },
            {
              type: "text",
              value: ` «Вафля, заєць&nbsp;— ваза», «бублик, лава, вафля&nbsp;— булава». Стежте за наголосом. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Дуже добре! А&nbsp;тепер ` },
            { type: "strong", value: ` поміняйтеся ролями: ` },
            {
              type: "text",
              value: ` дитина так само вголос загадує&nbsp;— ви відгадуєте. `,
            },
          ],
        },
        { type: "button", target: "next", value: "Розпочати гру" },
      ],
    },
    {
      articleId: "Molodets",
      content: [
        { type: "header1", value: "Молодець!" },
        {
          type: "text",
          value: [
            { type: "strong", value: `Відпочиваємо. ` },
            { type: "text", value: ` Нагадую: ` },
            { type: "strong", value: ` не варто поспішати` },
            {
              type: "text",
              value: `&nbsp;— ще є час до першого вересня. Краще&nbsp;неквапом щодня, аніж все й&nbsp;одразу, але з&nbsp;перевтомою. `,
            },
            {
              type: "strong",
              value: `Налаштовуйтесь на&nbsp;щоденний&nbsp;ритм! `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `А поки що ` },
            { type: "strong", value: `подивіться на наших учнів. ` },
            {
              type: "text",
              value: ` До речі, оті двійко хлопців уже на розширеному&nbsp;курсі `,
            },
            { type: "strong", value: `«Я читаю!»: ` },
          ],
        },
        {
          type: "image",
          value: "rebus-ditky",
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Викладайте і&nbsp;ви свої ` },
            {
              type: "link",
              href: "https://www.facebook.com/RebusMetod",
              value: "сюди на фейсбук",
            },
            { type: "text", value: ` підписуйтесь та теґайте нас ` },
            {
              type: "link",
              href: "https://www.instagram.com/rebusmetod/",
              value: "на інстаграмі",
            },
            {
              type: "text",
              value: ` або діліться фото й враженнями у&nbsp;коментарях нижче. `,
            },
          ],
        },
        {
          type: "strong",
          value: `Коментарі тимчасово вимкнено. Користуйтесь коментарями на Плані уроків.`,
        },
        {
          type: "hyperComments",
          value: "2-19",
        },
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "SohodniNoveZavdannya",
      content: [
        { type: "header1", value: "Сьогодні нове завдання" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Читаємо слово за допомогою картинок і&nbsp;клацаємо на правильний варіант. `,
            },
            {
              type: "text",
              value: `Не&nbsp;вгадали? Спробуймо ще раз&nbsp;— ми тут не ставимо жодних оцінок. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "strong", value: `Найголовніше&nbsp;— задоволення! ` },
          ],
        },
        {
          type: "text",
          value: `Дорослі можуть користуватися стрілочками, як і&nbsp;раніше. `,
        },
        { type: "header2", value: "О, і&nbsp;так, часто питають:" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Скільки всього уроків у&nbsp;курсі «Я починаю читати»? `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `У початковому курсі «Ребус-методу» ` },
            { type: "strong", value: `п’ять подарункових уроків. ` },
            {
              type: "text",
              value: ` Вони самі по собі&nbsp;— гарне тренування відчуття ритму, дикції і&nbsp;механіки читання. І хоча спершу лише картинками, ваша дитина дійсно почне читати. Далі, якщо методика підійде вашій дитині, ви зможете придбати повний курс «Я читаю!». До речі, наприкінці п’ятого уроку ви зможете поглянути на декілька карток з повного курсу, щоб краще зрозуміти, як проходитимуть подальші заняття. Там-таки на вас чекає вигідна пропозиція. Але про це пізніше. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Сплатити ви зможете будь-якою банківською карткою, `,
            },
            {
              type: "text",
              value: ` через Приват24 або на розрахунковий рахунок. Усі платежі проходять через безпечні шифровані з’єднання&nbsp;— ваші гроші захищені. Сервіс оплати надає платіжний партнер «Tranzzo». `,
            },
          ],
        },
        {
          type: "text",
          value: `Усі чеки, електронні виписки тощо&nbsp;— у&nbsp;ваших руках. `,
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Детальніше про розширений курс ви дізнаєтесь згодом, але якщо хочете отримати відповідь на якісь питання прямо зараз, `,
            },
            {
              type: "text",
              value: `телефонуйте на ${globals?.contactPhoneNumber} або й пишіть за адресою `,
            },
            {
              type: "link",
              href: "mailto:rebusmetod@gmail.com",
              value: "rebusmetod@gmail.com",
            },
          ],
        },
        {
          type: "text",
          value: `Ми відволіклися. Попереду ще багато карток з&nbsp;подарункових уроків, якими можна насолоджуватися просто так. `,
        },
        { type: "text", value: `Учень уже зачекався? ` },
        { type: "button", target: "next", value: "Розпочати урок" },
      ],
    },
    {
      articleId: "YakPravylno",
      content: [
        { type: "header1", value: "Як правильно?" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Іноді дорослі, навчаючи дитину за «Ребус-методом», припускаються низки помилок, які ускладнюють дитині найперший етап гри. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "strong", value: `Дуже поширеною помилкою ` },
            {
              type: "text",
              value: ` є спроба дорослого пояснити дитині, що в&nbsp;нашій грі з&nbsp;цілого слова треба виділити дві перші літери. По-перше, далеко не завжди цих літер дві. Приміром, у&nbsp;слові «яблуко» потрібно називати тільки «я», а&nbsp;у&nbsp;слові «брязкальце» за нашими правилами слід виділяти «бря». Тут фокус у&nbsp;тому, що орієнтуватися слід не на склади і&nbsp;літери, про які дитина ще поняття не має, а&nbsp;на `,
            },
            { type: "strong", value: `ударні голосні. ` },
            {
              type: "text",
              value: ` Договорюємо слово вголос до наголошеної голосної і&nbsp;спиняємося на ній. Але й&nbsp;тут не варто ускладнювати все поясненнями про наголос, дитина може просто не зрозуміти таких премудростей. `,
            },
            {
              type: "strong",
              value: `Достатньо спитати про «початок слова». `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Врахуйте, що діти майже усі наші пояснення розуміють не зовсім так, як ми очікуємо. `,
            },
            {
              type: "strong",
              value: `У&nbsp;дитини геть не таке уявлення про звуки, як у&nbsp;дорослих, `,
            },
            {
              type: "text",
              value: `і вона часто-густо не може зрозуміти, що таке «голосний» або «приголосний»&nbsp;— не може доти, доки не навчиться читанню по літерах. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Якщо у&nbsp;дитини дійсно виникло нерозуміння нашого першого правила&nbsp;— просто `,
            },
            { type: "strong", value: `пограйте у&nbsp;«зворотну» гру, ` },
            { type: "text", value: ` описану наприкінці попереднього уроку. ` },
          ],
        },
        { type: "header2", value: "Упорається" },
        {
          type: "text",
          value: [
            { type: "strong", value: `Іншою поширеною помилкою дорослих ` },
            {
              type: "text",
              value: ` є страх запропонувати дитині слова із трьох і&nbsp;більше кількості складів. Занадто довго деякі татусі&nbsp;й матусі дресирують малюка на двоскладових словах, і&nbsp;дитина починає нудитись. `,
            },
            {
              type: "strong",
              value: `Уже на першому занятті просто необхідно погратися з&nbsp;довгими словами, `,
            },
            {
              type: "text",
              value: `хоча б трошки. Так, безумовно, називати короткі слова дитині значно простіше, аніж довгі&nbsp;— потрібна менша концентрація уваги. Але при цьому в&nbsp;коротких словах важче зрозуміти сенс. Для розуміння короткого слова завелику роль відіграє наголос, а&nbsp;переставляти його дитина ще не вміє. Сенс довгого слова упізнається малюком набагато легше. А&nbsp;без сенсу читання стає геть нецікавим нудним заняттям. `,
            },
          ],
        },
        { type: "strong", value: `Упорається! ` },
        { type: "button", target: "next", value: "Поїхали" },
      ],
    },
    {
      articleId: "VyrizhIZahadayDruzyam",
      content: [
        { type: "header1", value: "Виріж і&nbsp;загадай друзям" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `А що як малюк буде загадувати слова не дорослим, а&nbsp;своїм одноліткам? `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Відкрийте ` },
            {
              type: "link",
              href: "https://www.rebusmetod.com/rozdrukuy",
              value: "файлик із ребусами",
            },
            {
              type: "text",
              value: `, роздрукуйте його, розріжте на окремі слова&nbsp;— і&nbsp; `,
            },
            {
              type: "strong",
              value: `вперед&nbsp;до&nbsp;садочку чи просто на вулицю. `,
            },
            {
              type: "text",
              value: `Чудова вправа і&nbsp;на дикцію, і&nbsp;на соціалізацію. `,
            },
          ],
        },
        {
          type: "text",
          value: [{ type: "strong", value: `Ви уже знаєте правила. ` }],
        },
        { type: "button", target: "endLesson", value: "Завершити урок" },
      ],
    },
    {
      articleId: "YakPochynavsyaRebusMetod",
      content: [
        { type: "header1", value: "Як починався «Ребус-метод»?" },
        {
          type: "text",
          value: `Перегляньте відео другої половини дев’яностих, на якому автор методики Лев Штернберг займається зі своїми першими учнями. `,
        },
        {
          type: "text",
          value: `Дитсадок у&nbsp;Мінську, 1997 рік. Раритет)) `,
        },
        { type: "button", target: "next", value: "Переглянути відео" },
        { type: "text", value: `або ` },
        {
          type: "button",
          target: "skipOne",
          value: "Продовжити навчання, не переглядаючи відео",
        },
      ],
    },
    {
      articleId: "DytsadokUMinsku",
      content: [
        { type: "header1", value: "Дитсадок у&nbsp;Мінську, 1997&nbsp;рік" },
        {
          type: "text",
          value: `Автор методики Лев Штернберг займається зі своїми першими учнями. `,
        },
        { type: "video", value: "t6q_udDvMu0" },
        { type: "button", target: "next", value: "Продовжити навчання" },
      ],
    },
    {
      articleId: "Podobayetsya",
      content: [
        { type: "header1", value: "Подобається?" },
        {
          type: "header2",
          value: [
            { type: "text", value: "Подарункові уроки закінчилися" },
            {
              type: "text",
              value: ", але можна поглянути на картки повного курсу",
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Багатьом із «Ребус-методом» весело, багатьом гратися подобається, та ще й&nbsp;читати мимоволі можна навчитися. Але як? Бо допоки&nbsp;ж ми читаємо лише картинками. На це можна буде краєм ока подивитися у&nbsp;наборі карток, довільним чином взятих із наступних уроків повного курсу.`,
            },
          ],
        },
        /*{
          type: "text",
          value: [
            {
              type: "strong",
              value: `Хочете поділитися своїм досвідом з іншими? `,
            },
            {
              type: "text",
              value: `Зробіть це, будь ласка, у коментарях під червоною кнопкою.`,
            },
          ],
        },
        {
          type: "text",
          value: user?.isSpecialOfferValid
            ? [
                {
                  type: "text",
                  value: `І ще. Лише протягом 24 годин для вас діє спеціальна одноразова пропозиція на розширений курс «Ребус-методу» «Я читаю!». `,
                },
                { type: "strong", value: `Так&nbsp;дешево не буде вже ніколи. ` },
                {
                  type: "text",
                  value: `Про це після огляду карток повного курсу. `,
                },
              ]
            : "",
        },
        */
        {
          type: "button",
          target: "next",
          value: "Що там далі?",
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Прочитавши відгуки інших, ` },
            {
              type: "strong",
              value: `поділіться враженнями про «Ребус-метод» у&nbsp;коментарях й самі. `,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `З якою проблемою прийшли? ` },
            { type: "listItem", value: `Які були сумніви? ` },
            {
              type: "listItem",
              value: `Які поточні результати у&nbsp;вашого малюка? `,
            },
          ],
        },
        {
          type: "strong",
          value: `Коментарі тимчасово вимкнено. Користуйтесь коментарями на Плані уроків.`,
        },
        {
          type: "hyperComments",
          value: "5-31",
        },
      ],
    },
    {
      articleId: "PodarunkoviUrokyZakinchylysya",
      isSkippedWhenPaid: true,
      content: [
        {
          type: "header1",
          value: [
            { type: "text", value: "Видалити цей урок! Подарункові уроки " },
            { type: "lineThrough", value: "закінчилися" },
            { type: "text", value: ", але можна відкрити ще кілька" },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Спершу я думав давати три додаткові уроки у&nbsp;подарунок за лайки, але якщо вже це подарунок, то хай і&nbsp;лишається подарунком. `,
            },
            {
              type: "text",
              value: `Перед вами ще три уроки. Щодо лайків, будь ласка, лайкніть «Ребус-метод» просто так: натисніть `,
            },
            { type: "strong", value: `«Подобається» ` },
            { type: "text", value: ` на кнопці Facebook ` },
            { type: "strong", value: `згори праворуч. ` },
          ],
        },
        {
          type: "text",
          value: `Раніше, тут були кнопки інших соц. мереж, але ми поважаємо указ Президента, і&nbsp;тепер кнопки прибрано. Але я вдячний кожному, хто натискав на ❤ і&nbsp;«Клас» у&nbsp;ВК і&nbsp;ОК. `,
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `І ще. Лише протягом 24 годин для вашого облікового запису діє спеціальна одноразова пропозиція на розширений курс «Ребус-методу» «Я читаю!». `,
            },
            { type: "strong", value: `Так дешево не буде вже ніколи. ` },
          ],
        },
        {
          type: "button",
          target: "salesPage",
          value: "Ознайомитись з&nbsp;розширеним курсом",
        },
        { type: "text", value: `Відкласти пропозицію і&nbsp;` },
      ],
    },
    {
      articleId: "YakSpravy",
      content: [
        { type: "header1", value: "Як справи?" },
        {
          type: "text",
          value: [
            { type: "strong", value: `То що, сподобалися друзям картки? ` },
            {
              type: "text",
              value: ` Якщо тоді роздрукувати не вдалося, ось знову `,
            },
            {
              type: "link",
              href: "https://www.rebusmetod.com/rozdrukuy",
              value: "посилання на документ",
            },
            { type: "text", value: `. Воно того варте! ` },
          ],
        },
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "PoradyAvtora",
      content: [
        { type: "header1", value: "Поради автора" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Ще раз нагадуємо вам, що «Ребус-метод»&nbsp;— це насамперед усна гра! `,
            },
            {
              type: "text",
              value: `Якщо дитина не навчилася грати в&nbsp;«Ребус-метод» усно&nbsp;— вважайте, що вона з&nbsp;цією грою взагалі не познайомилася і&nbsp;згаяла час без користі для себе. Тобто читати вона звичайно навчилася, але всі переваги цієї гри вона так і&nbsp;не пізнала. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `«Усна гра» означає, що ` },
            {
              type: "strong",
              value: `дитина не лише розгадує на слух ребуси, `,
            },
            {
              type: "text",
              value: `які їй загадує хтось інший, а&nbsp;й&nbsp;також `,
            },
            {
              type: "strong",
              value: `навчилася сама загадувати усні ребуси комусь іншому. `,
            },
            {
              type: "text",
              value: `Будь ласка, присвятіть десять додаткових хвилин тому, щоб намалювати їй у&nbsp;зошиті або `,
            },
            {
              type: "link",
              href: "https://www.rebusmetod.com/rozdrukuy",
              value: "роздрукувати картки",
            },
            {
              type: "text",
              value: ` і&nbsp;навчити дитину озвучувати кілька картинок поспіль. Дитина бачить ребус із трьох картинок «дошка&nbsp;— робот&nbsp;— гайка», і&nbsp;має вимовити усі ці три слова поспіль: «дошка&nbsp;— робот&nbsp;— гайка». `,
            },
            {
              type: "strong",
              value: `Ця найпростіша вправа таїть у&nbsp;собі ефект колосальної сили. `,
            },
            {
              type: "text",
              value: `По-перше, малюк вчиться вимовляти слова чітко й&nbsp;ритмічно, без зайвих пауз, без екання та жування слів&nbsp;— так, щоб його чули й&nbsp;розуміли. По-друге, він вчиться відстежувати реакцію свого партнера&nbsp;— чи почув партнер кожне вимовлене слово, чи встиг він запам’ятати весь ланцюжок із цих слів. Завдяки такій грі `,
            },
            {
              type: "strong",
              value: `у&nbsp;дитини розвивається увага до іншої людини. `,
            },
            {
              type: "text",
              value: `По-третє, озвучуючи ребуси, в&nbsp;яких є окремі приголосні літери, наприклад «беркут —ремінь&nbsp;— Г» або «вафля&nbsp;— голка&nbsp;— Н», дитина вчиться називати ці літери не як назви в&nbsp;абетці («Ге», «Ен», «Ре» або «Ер»), а&nbsp;як окремі короткі звуки. Ну і&nbsp;нарешті, `,
            },
            {
              type: "strong",
              value: `у&nbsp;«Ребус-методі» є&nbsp;безліч ребусів, `,
            },
            {
              type: "text",
              value: ` в&nbsp;яких картинки перемежовуються з&nbsp;літерними складами, наприклад «ЛО&nbsp;— палець&nbsp;— танк», або «борщ&nbsp;— ЛО&nbsp;— торт», чи «кошик&nbsp;— ЛО». При цьому до кожного екрану додано ключі-підказки у&nbsp;вигляді вже знайомих із базового курсу картинок з&nbsp;літерами. `,
            },
            {
              type: "strong",
              value: `Кілька разів вимовивши вголос «ло» в&nbsp;подібних ребусах, `,
            },
            { type: "text", value: `дитина відразу ` },
            { type: "strong", value: `розуміє, ` },
            {
              type: "text",
              value: `як кілька літер зливаються в&nbsp;єдиний склад, і&nbsp;тут-таки `,
            },
            { type: "strong", value: `запам’ятовує, ` },
            { type: "text", value: `як він виглядає і&nbsp;звучить. ` },
          ],
        },
        { type: "slider", value: "" },
        {
          type: "text",
          value: [
            { type: "strong", value: `Отже, усна гра має два варіанти: ` },
          ],
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `дорослий загадує дитині усні ребуси ` },
            {
              type: "listItem",
              value: `дитина загадує усні ребуси дорослому `,
            },
          ],
        },
        {
          type: "text",
          value: `У першому варіанті дорослий демонструє дитині, як це робиться, одразу називаючи незнайомі для дитини елементи&nbsp;— картинки, приголосні букви, відкриті склади або й&nbsp;спеціальні знаки і&nbsp;буквосполучення. `,
        },
        {
          type: "text",
          value: `У другому варіанті одразу буде видно, що дитина вже може зробити, а&nbsp;що — ще ні. Існує можливість (у якій іншій методиці це настільки ж просто?) відразу зауважити і&nbsp;виправити будь-яку помилку, якої припустилася дитина. `,
        },
        {
          type: "text",
          value: [
            { type: "text", value: `І можете бути впевнені: ` },
            {
              type: "strong",
              value: `навчившись гратися усно, дитина обов’язково побіжить до всіх своїх знайомих дорослих і&nbsp;дітей, `,
            },
            {
              type: "text",
              value: `і&nbsp;стане загадувати їм усні загадки&nbsp;— ребуси. `,
            },
          ],
        },
        { type: "button", target: "next", value: "Завершити урок" },
      ],
    },
    {
      articleId: "NaSyomyjDenZavedenoVidpochyvaty",
      content: [
        { type: "header1", value: "На сьомий день заведено&nbsp;відпочивати" },
        {
          type: "text",
          value: [
            { type: "strong", value: `Мультик для тих, хто старався! ` },
          ],
        },
        { type: "video", value: "c5Vz6ftqSL8" }, // Як киця та песик брудну підлогу мили
        { type: "header2", value: "Про що мріють діти на свята?" },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `А для дорослих — інша історія. `,
            },
            {
              type: "strong",
              value: `Іспанська ІКЕА вирішила провести несподіваний соціальний експеримент.  `,
            },
            {
              type: "text",
              value: `Компанія запросила десятеро діток писати листи до Трьох волхвів (це все одно як наші діти пишуть Миколаю). Листи вийшли довгими, дитячим бажанням не було краю. Те, що їм запропонували зробити далі, глибоко вразило мене і мою сім’ю. Лишень погляньте самі: `,
            },
          ],
        },
        { type: "video", value: "1Vi67jDSaMM" },
        // чомусь не працює. або працює дуже рідко. коли оновлюєш під час розробки
        {
          type: "strong",
          value: `Коментарі тимчасово вимкнено. Користуйтесь коментарями на Плані уроків.`,
        },
        {
          type: "hyperComments",
          value: "tyzhden",
        },
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "DavnoNePidvyshchuvalySkladnist",
      content: [
        { type: "header1", value: "Давно не підвищували складність" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Ми давно опанували три склади. З чотирма буде важче, їх в&nbsp;пам’яті важко утримати й&nbsp;шестирічкам: `,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            { type: "listItem", value: `Півень-рак-місяць-дах&nbsp;— … ` },
            { type: "listItem", value: `Бантик-рак-бантик-нитки&nbsp;— … ` },
            { type: "listItem", value: `Ангел-напій-напій-сито&nbsp;— … ` },
            { type: "listItem", value: `Бантик-танк-ремінь-яблуко&nbsp;— … ` },
          ],
        },
        {
          type: "text",
          value: `Важко. Діти забувають слова, плутаються, намагаються вгадати. Дається взнаки брак концентрації уваги, невміння зосередитись. Можна було б зупинитися на розвитку цих якостей і&nbsp;продовжити усне тренування. Та облишмо це і&nbsp;допоможімо діткам картинками. Вони слугуватимуть зоровою опорою. `,
        },
        { type: "button", target: "next", value: "Продовжити навчання" },
      ],
    },
    {
      articleId: 'SchoTamDali',
      content: [
        { type: 'header1', value: 'Що там далі?' },
        {
          type: 'text',
          value: [
            {
              type: 'text',
              value: `Обіцяли ж, що дитина вже скоро буде читати літерами! `,
            },
          ],
        },
        {
          type: 'text',
          value: [
            {
              type: 'text',
              value: `Саме так, вже з тринадцятого уроку почнемо читати і буквами. Там і окремі приголосні будуть, і мʼякий знак, і апостроф, і цілі історії-оповідки... Але поки що треба натренувати навичку усної гри. Та й нові картинки-склади самі себе не вивчать. `,
            },
          ],
        },
        {
          type: 'text',
          value: [
            {
              type: 'text',
              value: `Та все ж цікаво, як це виглядає. Зазирнімо наперед: нові прямокутнички згори картки. `
            },
            { type: 'strong', value: `Ми називаємо їх «ключами».  ` },
          ],
        },
        {
          type: 'text',
          value: `До кінця дванадцятого уроку дитина вже добре опанувала читання картинками, і зважаючи на те, що знати букви до початку курсу зовсім необов’язково, настає час гратися по-справжньому! `,
        },
        {
          type: 'text',
          value: `Коли в картці стоїть невідомий буквений склад, прочитати його можна в ключах. Треба лише знайти серед них такий самий. Бачиш невідому кракозябру — шукаєш її в ключах — читаєш! `,
        },
        {
          type: 'text',
          value: [
            { type: 'strong', value: `Є маленький секрет:  ` },
            {
              type: 'text',
              value: `в якийсь момент водити пальчиком від невідомих тобі букв до ключів стає ліньки — ми ж всі люди, і саме лінь рухає нашу цивілізацію. Тож мозок вирішує схитрувати, йому легше запам’ятати звук, який ці літери позначають, аніж щоразу напружувати увагу для виконання типової вже рутини пошуку відповідного ключа. `,
            },
          ],
        },
        {
          type: 'text',
          value: [
            { type: 'text', value: `Власне, саме цього нам і треба. ` },
            { type: 'strong', value: `Дитина починає читати літерами!  ` },
          ],
        },
        {
          type: 'text',
          value: [
            {
              type: 'text',
              value: `Деякі хитруни йдуть далі і починають зазирати до картинок-відповідей знизу картки, щоб не читати, а вгадувати відповідь. Для них можна включити `,
            },
            { type: 'strong', value: `хитрун-режим,  ` },
            {
              type: 'text',
              value: `натиснувши на сіре очко згори праворуч. В такому режимі і ключі, і відповіді доступні після додаткового торкання на відповідних зонах картки. Хитрун-режим вимикається таким самим торканням по відкритому тепер очку. `,
            },
          ],
        },
        { type: 'button', target: 'next', value: 'Зазирнути наперед' },
      ],
    }, {
      articleId: "ShchosNovenke",
      content: [
        {
          type: "text",
          value: [
            { type: "header1", value: "Щось новеньке" },
            { type: "text", value: `Нові прямокутнички згори картки. ` },
            { type: "strong", value: `Ми називаємо їх «ключами». ` },
          ],
        },
        {
          type: "text",
          value: `З тринадцятого уроку в&nbsp;курсі з’являються літери. Дитина вже добре опанувала читання картинками, і&nbsp;оскільки знати їх до початку курсу зовсім необов’язково, настає час гратися по-справжньому! `,
        },
        {
          type: "text",
          value: `Коли в&nbsp;картці стоїть невідомий буквений склад, прочитати його можна в&nbsp;ключах. Треба лише знайти серед них такий самий. Ключі тепер будуть з&nbsp;вами на&nbsp;кожному уроці. `,
        },
        {
          type: "text",
          value: [
            { type: "strong", value: `Є маленький секрет: ` },
            {
              type: "text",
              value: ` в&nbsp;якийсь момент водити пальчиком від невідомих букв-кракозябрів до ключів стане ліньки&nbsp;— ми ж всі люди, і&nbsp;саме лінь рухає нашу цивілізацію. Тож мозок вирішить схитрувати, йому легше буде запам’ятати звук, який ці літери позначають, аніж щоразу напружувати увагу для виконання типової вже рутини пошуку відповідного ключа. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "text", value: `Власне, саме цього нам і&nbsp;треба. ` },
            { type: "strong", value: `Дитина починає читати літерами! ` },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Деякі хитруни йдуть далі і&nbsp;починають зазирати до картинок-відповідей знизу картки, щоб не читати, а&nbsp;вгадувати відповідь. Для них можна включити `,
            },
            { type: "strong", value: `хитрун-режим, ` },
            {
              type: "text",
              value: ` натиснувши на сіре очко згори праворуч. В такому режимі і&nbsp;ключі, і&nbsp;відповіді доступні після додаткового торкання на відповідних зонах картки. Хитрун-режим вимикається таким самим торканням по відкритому тепер очку. `,
            },
          ],
        },
        { type: "button", target: "next", value: "Що там, що там?" },
      ],
    },
    {
      articleId: "IZnovuDenVidpochynku",
      content: [
        { type: "header1", value: "І знову день відпочинку" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Який мультик показати наступного разу? `,
            },
          ],
        },
        { type: "video", value: "Tnh1E4SDvwI" }, // Петрик П’яточкін
        {
          type: "strong",
          value: `Коментарі тимчасово вимкнено. Користуйтесь коментарями на Плані уроків.`,
        },
        {
          type: "hyperComments",
          value: "14-21",
        },
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "VzheYTretiyTyzhdenPozadu",
      content: [
        { type: "header1", value: "Вже й&nbsp;третій тиждень позаду" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Насправді, кожен займається зі своєю швидкістю, але мультики люблять всі `,
            },
          ],
        },
        { type: "video", value: "u6RtKb2YPuY" }, // Капітошка
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "ANeTakVzheYBahatoLyshylosya",
      content: [
        {
          type: "header1",
          value: "А не так вже й&nbsp;багато уроків лишилося",
        },
        {
          type: "text",
          value: [{ type: "strong", value: `Винагорода за старання ` }],
        },
        { type: "video", value: "MCIewxo6o6c" }, // Івасик Телесик
        { type: "button", target: "endLesson", value: "Закінчити урок" },
      ],
    },
    {
      articleId: "DyakuyuShchoMyBulyRazom",
      content: [
        { type: "header1", value: "Дякую, що ми були разом!" },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Вітаю! Ви закінчили навчання за «Ребус-методом». `,
            },
          ],
        },
        {
          type: "text",
          value: `Чи не погодились би ви відповісти на декілька запитань? `,
        },
        {
          type: "unorderedList",
          value: [
            {
              type: "listItem",
              value: `Що далося легко? З чим виникали складнощі? `,
            },
            {
              type: "listItem",
              value: `Які були сумніви з&nbsp;самого початку? Які з&nbsp;них розвіялись? `,
            },
            { type: "listItem", value: `Які у&nbsp;вас поточні результати? ` },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Будь ласка, поділіться своїми враженнями у&nbsp;коментарях на сторінці із планом уроків, або надішліть листа на адресу `,
            },
            {
              type: "link",
              href: "mailto:rebusmetod@gmail.com?Subject=Відгук",
              value: "rebusmetod@gmail.com",
            },
            { type: "text", value: `. Діліться враженнями ` },
            {
              type: "link",
              href: "https://www.facebook.com/RebusMetod",
              value: "на фейсбуці",
            },
            { type: "text", value: ` та теґайте нас у&nbsp;` },
            {
              type: "link",
              href: "https://www.instagram.com/rebusmetod/",
              value: "інстаграмі",
            },
            { type: "text", value: `.` },
          ],
        },
        {
          type: "text",
          value: [
            { type: "highlight", value: `Новинка!` },

            {
              type: "strong",
              value: ` «Ребус-метод» безкоштовно за відео від вас. `,
            },
            {
              type: "text",
              value: ` Зніміть відео-відгук і&nbsp;отримайте сплачену вами вартість курсу назад. Як поповнення мобільного або як виплату на картку. На відео дайте відповіді на перелічені вище запитання або й&nbsp;просто покажіть як читає ваша дитина. `,
            },
          ],
        },
        {
          type: "text",
          value: `Зателефонуйте ${globals?.contactPhoneNumber}, якщо вас цікавлять подробиці. `,
        },
        { type: "header2", value: "Що далі?" },
        {
          type: "text",
          value: `Якщо хочеться гратися ще, перед вами 16 бонусних уроків. В них нема картинок, лише ключі. Тренуйся досхочу. Це — подарунок, і&nbsp;платити не треба. `,
        },
        {
          type: "strong",
          value: `Коментарі тимчасово вимкнено. Користуйтесь коментарями на Плані уроків.`,
        },
        {
          type: "hyperComments",
          value: "32-32",
        },
        { type: "button", target: "endLesson", value: "До плану уроків" },
      ],
    },
    {
      articleId: "YarPrydbaty",
      isSkippedWhenPaid: true,
      startSpecialOfferCountDown: true,
      content: [
        { type: "header1", value: "Як придбати повний курс «Ребус-методу»?" },
        {
          type: "header2",
          value: `Вітаю, ${user?.callingName || "читачу"}!`,
        },
        {
          type: "text",
          value: [
            user?.isSpecialOfferValid
              ? {
                type: "text",
                value: [
                  {
                    type: "text",
                    value: `Найвигіднішим варіантом буде скористатися `,
                  },
                  { type: "strong", value: `одноразовою пропозицією` },
                  {
                    type: "text",
                    value: `&nbsp;— повний курс коштуватиме для вас `,
                  },
                  {
                    type: "strong",
                    value: `${globals?.prices?.fullCourseSpecialOffer}&nbsp;грн. `,
                  },
                  {
                    type: "text",
                    value: `Ця пропозиція діє доти, доки ви не пройдете п’ять перших уроків, а&nbsp;також ще 24 години після того. `,
                  },
                ],
              }
              : {
                type: "text",
                value: [
                  {
                    type: "text",
                    value: `Повний курс коштує для вас `,
                  },
                  {
                    type: "strong",
                    value: `${globals?.prices?.fullCourse}&nbsp;грн. `,
                  },
                ],
              },
            {
              type: "text",
              value: `Сплатити можна будь-якою банківською карткою через інтернет або на розрахунковий рахунок. Якщо хочете сплатити прямо зараз, це можна зробити `,
            },
            {
              type: "link",
              href: "paymentTable",
              value: `натиснувши тут`,
            },
            {
              type: "text",
              value: ` або скориставшись червоною кнопкою `,
            },
            {
              type: "strong",
              value: `«Продовжити навчання!» `,
            },
            {
              type: "text",
              value: `нижче.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            user?.isSpecialOfferValid
              ? {
                type: "strong",
                value: `Це коротко, щоб не вдаватися у&nbsp;деталі. `,
              }
              : "",
            user?.isSpecialOfferValid
              ? {
                type: "text",
                value: ` Якщо трошки докладніше: у&nbsp;курсі 32 уроки, з&nbsp;них п’ять подарункових. Вони самі по собі&nbsp;— гарне тренування відчуття ритму, дикції і&nbsp;механіки читання. І хоча спершу лише картинками, ваша дитина дійсно починає читати. Далі, якщо методика подобається вам і&nbsp;підходить вашій дитині, ви можете придбати повний курс. Поки ви не дійшли до кінця п’ятого уроку (а також впродовж доби після того, як ви його вперше відкрили), ви можете придбати його за акційною ціною у&nbsp;`,
              }
              : {
                type: "text",
                value: `У&nbsp;курсі 32 уроки, п’ять подарункових з них ви вже пройшли. Ви могли помітити, вони самі по собі&nbsp;— гарне тренування відчуття ритму, дикції і&nbsp;механіки читання. І хоча спершу лише картинками, ваша дитина дійсно вже починає читати. Цьому допоможуть і&nbsp;16&nbsp;додаткових, бонусних уроків, які закріплюють отримані навички. Якщо методика подобається вам і&nbsp;підходить вашій дитині, на цій сторінці ви можете придбати повний курс. `,
              },
            user?.isSpecialOfferValid
              ? {
                type: "strong",
                value: `${globals?.prices?.fullCourseSpecialOffer}&nbsp;грн. `,
              }
              : "",
            user?.isSpecialOfferValid
              ? {
                type: "text",
                value: `Якщо вирішите не користуватись такою пропозицією, ціна збільшується до `,
              }
              : "",
            user?.isSpecialOfferValid
              ? {
                type: "strong",
                value: `${globals?.prices?.fullCourse}&nbsp;грн. `,
              }
              : "",
            user?.isSpecialOfferValid
              ? {
                type: "text",
                value: `Можна замовляти «Ребус-метод» окремими уроками, це не так вигідно, але може допомогти прийняти для себе свідоме рішення про купівлю повного курсу.`,
              }
              : "",
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Оплата карткою працює просто в&nbsp;інтернеті, і&nbsp;доступ відкривається автоматично, впродовж секунд. `,
            },
            {
              type: "strong",
              value: `Доступ не обмежений у&nbsp;часі, жодних додаткових проплат не передбачено. Це не підписка. `,
            },
            {
              type: "text",
              value: `Якщо зручніше зробити переказ, ви отримаєте реквізити.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `Також можна задонатити на ЗСУ 🇺🇦  `,
            },
            {
              type: "text",
              value: `Просто пришліть свіжу квитанцію, для мене буде за честь відрити вам доступ на знак подяки. Контакти внизу сторінки. Якщо&nbsp;ж через російську агресію зовсім скрутно, перейдіть на план уроків, гортайте до самого низу та тисніть українське сердечко. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `А тепер про сам повний курс. `,
            },
            {
              type: "text",
              value: `Логічним продовженням перших занять є курс `,
            },
            {
              type: "strong",
              value: `«Я читаю!». `,
            },
            {
              type: "text",
              value: `Це `,
            },
            {
              type: "strong",
              value: `27 нових (+16 бонусних) уроків, `,
            },
            {
              type: "text",
              value: `складність яких поступово зростає. Вони закріплюють отримані навички і&nbsp;вчать нового.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "header2", value: "Що всередині?" },
            {
              type: "text",
              value: `Наступний блок виводить навчання на якісно новий рівень. Подивіться, що ви отримаєте: `,
            },
            {
              type: "unorderedList",
              value: [
                {
                  type: "listItem",
                  value: [
                    { type: "strong", value: `27 (+16) нових уроків, ` },
                    {
                      type: "text",
                      value: `складність яких поступово зростає `,
                    },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "text", value: `Понад ` },
                    { type: "strong", value: `710 (+456) нових карток ` },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "text", value: `Поступове, ретельно прораховане ` },
                    { type: "strong", value: `збільшення складності уроків ` },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "strong", value: `Нові склади-ключі, ` },
                    {
                      type: "text",
                      value: `адже у&nbsp;базовому курсі ми лише почали `,
                    },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "text", value: `Читання ` },
                    { type: "strong", value: `виключно складами, ` },
                    { type: "text", value: `без картинок ` },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "strong", value: `Слова із приголосними ` },
                    {
                      type: "text",
                      value: `(«ді`,
                    },
                    { type: "strong", value: `в` },
                    {
                      type: "text",
                      value: `чина», «ту`,
                    },
                    { type: "strong", value: `ф` },
                    {
                      type: "text",
                      value: `лі», «рю`,
                    },
                    { type: "strong", value: `к` },
                    {
                      type: "text",
                      value: `за`,
                    },
                    { type: "strong", value: `к` },
                    {
                      type: "text",
                      value: `», «га`,
                    },
                    { type: "strong", value: `р` },
                    {
                      type: "text",
                      value: `бузи»…) `,
                    },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "strong", value: `Слова із м’яким знаком ` },
                    { type: "text", value: `(«кінь», «кулька», «велетень»…) ` },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "strong", value: `Слова підвищеної складності ` },
                    {
                      type: "text",
                      value: `(«квитки», «шарф», «крем», «гномик»…) `,
                    },
                  ],
                },
                {
                  type: "listItem",
                  value: [
                    { type: "text", value: `І звичайно ж, ` },
                    { type: "highlight", value: ` «молодець»` },
                    { type: "text", value: ` наприкінці навчання!` },
                  ],
                },
              ],
            },
            {
              type: "button",
              target: "skipToContent",
              value: "Продовжити навчання!",
            },
            // {
            //   type: "text",
            //   value: `Ось приклади деяких уроків: `,
            // },
            // {
            //   type: "text",
            //   value: `Вирішити, як показувати подальші уроки !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!
            //  `,
            // },
          ],
        },
        {
          type: "text",
          value: [
            { type: "header2", value: "Ви теж бажаєте успіху своїй дитині?" },
            {
              type: "text",
              value: `Певно, ви й&nbsp;самі знаєте, що саме треба знати і&nbsp;вміти дитині, щоб потрапити до першого класу. `,
            },
            {
              type: "strong",
              value: `У багатьох школах дітей приймають лише після проходження додаткових тестів. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Я дізнавався: треба рахувати до двадцяти й&nbsp;десятками до сотні у&nbsp;прямому й&nbsp;зворотному напрямку, володіти знаннями про довколишній світ, демонструвати основи логічного мислення `,
            },
            {
              type: "strong",
              value: `і&nbsp;звичайно ж, вміти читати. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Звучить трохи нелогічно&nbsp;— вміти читати, щоб потім увесь перший клас вчитися читати, проте це наша реальність. Потрапити в&nbsp;хороші школи доволі важко. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "header2", value: "Скільки вам це коштуватиме?" },
            {
              type: "image",
              value: "boy-tired",
            },
            {
              type: "text",
              value: `Звичайно ж, можна `,
            },
            {
              type: "strong",
              value: `готувати дитину самотужки, `,
            },
            {
              type: "text",
              value: `хоча не завжди на це є достатньо часу. `,
            },
            {
              type: "strong",
              value: `Можна сподіватися на дитячий садок, `,
            },
            {
              type: "text",
              value: `іноді трапляються вихователі-професіонали, але вимагати такої освіти від них ви не можете. Та й&nbsp;груповий метод навчання не передбачає стовідсоткової уваги кожному.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Можна `,
            },
            {
              type: "strong",
              value: `займатися із репетитором. `,
            },
            {
              type: "text",
              value: `Хороший варіант. У&nbsp;містах одне заняття коштуватиме десь `,
            },
            {
              type: "strong",
              value: `${cmp.tutorLessonMin}–${cmp.tutorLessonMax} гривень. `,
            },
            {
              type: "text",
              value: `Якщо викликати репетитора до себе додому, ціна зростає. Скільки занять потрібно, аби ваш малюк навчився читанню традиційними методами? Скажімо, від двадцяти.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "text",
              value: `Тобто `,
            },
            {
              type: "highlight",
              value: `щонайменше це ${groupThousands(cmp.selfTeachingTotalMin)}–${groupThousands(cmp.selfTeachingTotalMax)}+ гривень. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            { type: "header2", value: "Але не для вас" },
            {
              type: "text",
              value: `Спершу, подивившись на ціну відомих кубиків для навчання читанню (до речі, теж хороша методика), я продавав повний доступ за суму, що можна порівняти із цінами, наведеними вище, але згодом, поспілкувавшись з&nbsp;батьками, що хотіли купити курс, вирішив знизити базову ціну до `,
            },
            {
              type: "strong",
              value: `${globals?.prices?.fullCourse}&nbsp;грн. `,
            },
          ],
        },
        user?.isSpecialOfferValid
          ? {
            type: "text",
            value: [
              {
                type: "text",
                value: `Нагадую, за умовами акції, для вас розширений курс «Ребус-методу» доступний лише за `,
              },
              {
                type: "highlight",
                value: `${globals?.prices?.fullCourseSpecialOffer}&nbsp;грн.`,
              },
              {
                type: "text",
                value: ` Чому діє знижка? Що раніше ви почнете, то раніше вивчиться ваша дитина. У&nbsp;неї буде більше можливостей попрацювати над швидкістю читання у&nbsp;подальшому. Адже, нема чого ховати, сам по собі «Ребус-метод» дає хорошу основу. Далі треба буде продовжувати вчитися: підшукувати цікаві саме вашому малюкові текстики&nbsp;— прості речення, віршики, коротенькі оповіданнячка. Тож `,
              },
              {
                type: "link",
                href: "paymentTable",
                value: `зробіть замовлення`,
              },
              {
                type: "text",
                value: ` зараз, щоб скористатися вигідною пропозицією. `,
              },
              {
                type: "strong",
                value: `Жодних додаткових прихованих проплат не передбачено. `,
              },
              {
                type: "text",
                value: `Ви отримуєте повний доступ до всіх уроків.`,
              },
            ],
          }
          : {
            type: "text",
            value: [
              {
                type: "strong",
                value: `Жодних додаткових прихованих проплат не передбачено. `,
              },
              {
                type: "text",
                value: `Ви отримуєте повний доступ до всіх уроків повного курсу, після проходження якого автоматично відкриються бонусні уроки. `,
              },
            ],
          },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "А якщо мені не сподобається?",
            },
            {
              type: "highlight",
              value: `100% гарантія результату!`,
            },
            {
              type: "text",
              value: ` Якщо, за умови регулярних якісних занять упродовж місяця, ваша дитина не навчиться читати, я обіцяю `,
            },
            {
              type: "strong",
              value: `повернути вам `,
            },
            {
              type: "text",
              value: `у&nbsp;повному обсязі `,
            },
            {
              type: "strong",
              value: `усі сплачені вами кошти `,
            },
            {
              type: "text",
              value: `будь-яким зручним для вас способом `,
            },
            {
              type: "strong",
              value: `на першу вашу вимогу. `,
            },
            {
              type: "text",
              value: `Ви сплатите лише за зворотний грошовий переказ у&nbsp;межах звичайних платіжних комісій.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "Як читає дитина за рік після навчання?",
            },
            { type: "video", value: "oBBnObbC41w" },
          ],
        },
        {
          type: "review",
          avatar: "avatar-01",
          value: `«Чудовий метод навчання читанню! Дитина дійсно дуже бистро вчить нові склади! Дякую Вам величезне, будемо рекомендувати Вас усім друзям з&nbsp;маленькими дітьми! Успіхів Вам!»&nbsp;— Ольга Ларкіна. `,
        },
        {
          type: "review",
          avatar: "avatar-02",
          value: `«Мій малий весь час відмовлявся вчитися читати, хоча багато його однолітків вже давно навчились. А&nbsp;це чоловік знайшов „Ребус-метод“, завдяки якому він вже за пару тижнів читав по складах. І при цьому сам просився: „Тату, давай позаймаємось «Ребус-методом»“. Я просто вражена&nbsp;— і&nbsp;методом, і&nbsp;результатом! Дуже дякую!!»&nbsp;— Є. Л. `,
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "Для кого підходить розширений курс?",
            },
            {
              type: "image",
              value: "girl-reading-a-book",
            },
            {
              type: "text",
              value: `Виходячи з&nbsp;досвіду використання методики, я наполегливо раджу розширений курс «Ребус-методу»:`,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            {
              type: "listItem",
              value: [
                {
                  type: "strong",
                  value: `Малюкам, чий природний слух ще не зламаний `,
                },
                { type: "text", value: `розвитком фонематичного слуху ` },
              ],
            },
            {
              type: "listItem",
              value: [
                {
                  type: "strong",
                  value: `Дітям, які пробували інші методики, `,
                },
                {
                  type: "text",
                  value: `але й&nbsp;досі плутаються і&nbsp;не розуміють, як читати `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "strong", value: `Зайнятим батькам, ` },
                {
                  type: "text",
                  value: `які люблять своїх дітей і&nbsp;хочуть, не витрачаючи додаткових зусиль, навчити свою дитину читати `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "strong", value: `Бабусям і&nbsp;дідусям, ` },
                {
                  type: "text",
                  value: `які готові допомогти своїм дітям із навчанням онуків `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                {
                  type: "strong",
                  value: `Викладачам курсів раннього розвитку дітей `,
                },
                {
                  type: "text",
                  value: `— для комерційного використання діють спеціальні пропозиції `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "text", value: `Дітям із легастенією&nbsp;—  ` },
                { type: "strong", value: `усім, хто втратив надію читати ` },
                { type: "text", value: `з&nbsp;легкістю і&nbsp;задоволенням ` },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "text", value: `Усім, хто хоче зробити ` },
                { type: "strong", value: `класний і&nbsp;корисний подарунок ` },
                { type: "text", value: `малюкові та його батькам ` },
              ],
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "Кому курс не потрібен?",
            },
            {
              type: "text",
              value: `Проте немає сенсу купувати «Ребус-метод», якщо:`,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            {
              type: "listItem",
              value: [
                { type: "text", value: `Ваші діти ще не досягли ` },
                { type: "strong", value: `чотирирічного віку. ` },
                {
                  type: "text",
                  value: `Курс наврядчи стане вам корисним. Краще зачекайте `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                {
                  type: "text",
                  value: `Ви не хочете `,
                },
                { type: "strong", value: `перенавантажувати ` },
                {
                  type: "text",
                  value: `свою дитину заняттями або цінуєте традиційні, а не ігрові методи навчання. Це нормально, ми усі різні, і наші цінності і прагнення різняться `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "text", value: `Ви ` },
                {
                  type: "strong",
                  value: `не готові приділяти малюкові додаткової уваги і&nbsp;допомоги `,
                },
                {
                  type: "text",
                  value: `в опануванні курсом. Комп’ютер комп’ютером, а&nbsp;любов і&nbsp;підтримка потрібна кожній дитині `,
                },
              ],
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "Легко заплатити",
            },
            {
              type: "image",
              value: "boy-stuying",
            },
            {
              type: "strong",
              value: `Завдяки платіжному партнеру «Tranzzo», миттєвий доступ відразу після оплати доступний для таких платіжних систем, широко розповсюджених на території України:`,
            },
          ],
        },
        {
          type: "unorderedList",
          value: [
            {
              type: "listItem",
              value: [
                { type: "strong", value: `Visa та MasterCard. ` },
                {
                  type: "text",
                  value: `Будь-яка банківська карта, випущена в&nbsp;Україні чи за її межами, для якої включено оплату через інтернет. Ви контролюєте платіж за допомогою свого мобільного `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "strong", value: `Apple Pay та Google Pay. ` },
                {
                  type: "text",
                  value: `Зручний та швидкий спосіб від світових технологічних компаній `,
                },
              ],
            },
            {
              type: "listItem",
              value: [
                { type: "strong", value: `Розрахунковий рахунок. ` },
                {
                  type: "text",
                  value: `У відділенні будь-якого банку або через мобільний застосунок вашого банку `,
                },
              ],
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: user?.isSpecialOfferValid
                ? `Ціна курсу «Я читаю!», за умовами акційної пропозиції, становить для вас ${globals?.prices?.fullCourseSpecialOffer}&nbsp;грн.`
                : `Ціна курсу «Я читаю!» <br />становить для вас ${globals?.prices?.fullCourse}&nbsp;грн.`,
            },
            {
              type: "text",
              value: `Щоб сплатити, оберіть, будь ласка, зручний для вас `,
            },
            {
              type: "strong",
              value: `спосіб&nbsp;оплати, `,
            },
            {
              type: "text",
              value: `далі введіть`,
            },
            {
              type: "strong",
              value: `номер контактного телефону, `,
            },
            {
              type: "text",
              value: `і натисніть `,
            },
            {
              type: "strong",
              value: `блакитну кнопку. `,
            },
          ],
        },
        { type: "id", value: "paymentTable" },
        {
          type: "paymentTable",
          value: globals,
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: "Так, але…",
            },
            {
              type: "strong",
              value: `«Мені достатньо базового курсу…»<br> `,
            },
            {
              type: "text",
              value: `— Базовий курс необхідний, щоб розпочати, і&nbsp;він вже робить для вас свою роботу. Та для просування вперед і&nbsp;якісного навчання, заняття варто продовжувати. Розширений курс зосереджується на закріпленні отриманих навичок та дає нові буквосполучення, без опанування яких читання буде не повноцінним. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«Розширений курс занадто дорогий…» <br>`,
            },
            {
              type: "text",
              value: `— `,
            },
            user?.isSpecialOfferValid && {
              type: "text",
              value: `Зараз для вас діє акційна знижка. `,
            },
            {
              type: "text",
              value: `Згадайте про альтернативи, подумайте, чи маєте ви достатньо часу, щоб продовжувати навчання самотужки.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«А мені не доведеться за щось ще платити?..» <br>`,
            },
            {
              type: "text",
              value: `— Ні. Ви платите зазначену суму за весь курс, що складається з&nbsp;32 (+16) уроків. Жодних прихованих доплат не передбачено. Ви можете навчати свою дитину, дітей своїх родичів і&nbsp;близьких. Додаткові спеціальні умови діють лише для комерційного використання курсу. `,
            },
            user?.isSpecialOfferValid && {
              type: "text",
              value: `Також пам’ятайте, що якщо ви не скористаєтесь одноразовою пропозицією, ціна зросте. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«З навчанням можна не поспішати. До школи ще далеко…» <br>`,
            },
            {
              type: "text",
              value: `— Починати варто якнайраніше. Сам по собі «Ребус-метод» дає чудовий старт, але це не означає, що далі можна буде поставити собі відповідну галочку і&nbsp;закинути читання до співбесіди. Що більше читатиме малюк надалі, то вищою буде його швидкість розуміння прочитаного. Додатковий час зіграє вам на руку.`,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«Хіба можна навчитися читати так швидко?..» <br>`,
            },
            {
              type: "text",
              value: `— Для того щоб правильно оволодіти механікою читання, потрібно не так уже й&nbsp;багато часу. Але щоб навчитись читати вільно, знадобляться роки. Ніхто з&nbsp;дошкільнят не читає семитомник «Гаррі Поттера». І малюкові наразі важливо розширити обрії, навчившись читати складніші слова, і&nbsp;закріпити набуті навички. У&nbsp;цьому розширенний курс для вашої дитини&nbsp;— 🪄&nbsp;незамінна чарівна паличка. Ви також маєте знати, що не всі діти однаково швидко опановують курс, у&nbsp;кожного своя швидкість. Буває, треба повернутися і&nbsp;пройти складні місця повторно. До того ж, на «Ребус-методі» навчання не закінчиться, будьте готові підшукати простенькі цікаві саме для вашої дитини тексти для подальших тренувань. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«Навіщо платити за курс, якщо можна зробити все традиційними методами…» <br>`,
            },
            {
              type: "text",
              value: `— Звичайно, можна. Проте подумайте, чи хочете ви розтягувати навчання на довший час. Чи хочете самостійно заохочувати учня до навчання. Чи, можливо, хочете подарувати своїй дитині задоволення від читання вже зараз, і&nbsp;спостерігати як вона сама просить гратися ще і&nbsp;ще. Це поширена практика серед клієнтів, якою вони час від часу діляться у&nbsp;своїх відгуках та у&nbsp;приватних розмовах. `,
            },
          ],
        },
        {
          type: "text",
          value: [
            {
              type: "strong",
              value: `«А все ж таки, чи можна отримати знижку?..» <br>`,
            },
            {
              type: "text",
              value: `— Так. Пройдіть розширений курс і&nbsp;запишіть відгук-інтерв’ю, давши відповіді на мої до вас запитання. Зніміться на відео разом зі своєю дитиною, розкажіть про свій досвід проходження курсу,&nbsp;— і&nbsp;я обіцяю вам щедру компенсацію. Компенсація здійснюється у&nbsp;вигляді поповнення рахунку вашого мобільного або за допомогою грошових переказів. Поспішайте, ця пропозиція короткострокова&nbsp;— мені потрібно не так уже й&nbsp;багато відгуків. Зв’язатися зі мною можна, скориставшись посиланням «Контакти» на сторінці із планом уроків. `,
            },
          ],
        },
        {
          type: "button",
          target: "skipToContent",
          value: "Перейти до сплати",
        },
        {
          type: "text",
          value: [
            {
              type: "header2",
              value: `Вам можна довіряти?`,
            },
            {
              type: "text",
              value: [
                {
                  type: "strong",
                  value: `Так. <br>`,
                },
                {
                  type: "text",
                  value: `Якщо у&nbsp;вас залишаються сумніви, подзвоніть ${globals?.contactPhoneNumber} і&nbsp;попросіть пробний доступ до наступних уроків на добу за просто так. Сплатите коли пересвідчитесь.`,
                },
              ],
            },
          ],
        },
        {
          type: "small",
          value: [
            {
              type: "link",
              href: "https://rebusmetod.com/kontakty/",
              value: "Контакти",
            },
          ],
        },
        {
          type: "small",
          value: [
            {
              type: "link",
              href: "https://rebusmetod.com/publichnyj-dohovir/",
              value: "Публічний договір",
            },
          ],
        },
      ],
    },
  ];
};
